import { AutoCompleteItem } from "@/components/Dropdown/Dropdown";

import { HubspotField } from "../schema/hubspot";

export const HUBSPOT_LEAD_TYPE_FIELD = "hs_lead_type";
export const HUBSPOT_LEAD_LABEL_FIELD = "hs_lead_label";

export const sanitizeStr = (value: string | null | undefined): string | null => {
	if (!value || value === "undefined" || value === "null") {
		return null;
	}

	return value;
};

export const getHubspotFieldOptions = (
	fields: HubspotField[] | undefined,
	fieldName: string
): AutoCompleteItem[] =>
	fields
		?.find((field) => field.name === fieldName)
		?.options?.map((option) => ({ id: option.value, title: option.label })) ?? [];

export const getAllowedOptionValue = (
	value: string | null | undefined,
	options: AutoCompleteItem[]
): string | null => {
	const sanitizedValue = sanitizeStr(value);

	if (!sanitizedValue || !options.some((option) => option.id === sanitizedValue)) {
		return null;
	}

	return sanitizedValue;
};
